import {
    GET_PROVIDERS_OUTSTANDING_RESPONSE,
    GET_TRANSACTIONS_RESPONSE,
    GET_SETTLEMENTS_RESPONSE,
    GET_REQUEST_STATUS,
    GET_FIXED_COMMISSION_FEES_RESPONSE
} from './types'

const INITIAL_STATE = {
   list: [],
   meta: {},
   transactions: [],
   transactionsMeta: {},
   settlementConfirmationData: {},
   settlements: [],
   settlementsMeta: {},
   fixedCommissionFees: [],
   fixedCommissionFeesMeta: {},
   requestStatus: null,
}

const outstandingBalance = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PROVIDERS_OUTSTANDING_RESPONSE:
            return {
                ...state,
                list: action.payload.list,
                meta: action.payload.meta,
            }
        case GET_TRANSACTIONS_RESPONSE:
            return {
                ...state,
                transactions: action.payload.transactions,
                transactionsMeta: action.payload.transactionsMeta,
                settlementConfirmationData: action.payload.settlementConfirmationData,
            }
        case GET_SETTLEMENTS_RESPONSE:
            return {
                ...state,
                settlements: action.payload.settlements,
                settlementsMeta: action.payload.settlementsMeta,
            }
        case GET_FIXED_COMMISSION_FEES_RESPONSE:
            return {
                ...state,
                fixedCommissionFees: action.payload.fixedCommissionFees,
                fixedCommissionFeesMeta: action.payload.fixedCommissionFeesMeta,
            }
        case GET_REQUEST_STATUS:
            return {
                ...state,
                requestStatus: action.payload === null ? null : action.payload,
            };
        default:
            return state;
    }
};

export default outstandingBalance;